import { clamp } from "lib";

export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

// takes a month number and returns the name of the month
export const getMonthName = monthNumber =>
  months[clamp(monthNumber - 1, 0, 11)];
